import CloseIcon from '@/assets/CloseIcon';

type TopModalSectionProps = {
	close: () => void;
	title?: string;
	className?: string;
};
const TopModalSection = ({
	close,
	title,
	className = 'gap-x-4 border-b py-2 w-full',
}: TopModalSectionProps) => {
	return (
		<div className={`flex items-center justify-between px-2 ${className}`}>
			<div className="flex items-center gap-x-2">
				<button
					type="button"
					className="relative inline-flex items-center justify-center overflow-hidden rounded-md outline-none h-7 w-7 p-1 transition ease-in duration-100 hover:bg-gray-100"
					data-test="top-close-modal-button"
					onClick={() => close()}
				>
					<CloseIcon width={20} height={20} />
				</button>
				<kbd className="bg-gray-200 inline-flex h-5 w-fit min-w-[20px] items-center justify-center rounded-md border px-1">
					esc
				</kbd>
			</div>
			{title}
		</div>
	);
};

export default TopModalSection;
